function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMicrosoft = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1289"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 286",
    style: {
      fill: "#f25022"
    },
    d: "M0 0h8v8H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 287",
    transform: "translate(0 9)",
    style: {
      fill: "#00a4ef"
    },
    d: "M0 0h8v8H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 288",
    transform: "translate(9)",
    style: {
      fill: "#7fba00"
    },
    d: "M0 0h8v8H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 289",
    transform: "translate(9 9)",
    style: {
      fill: "#ffb900"
    },
    d: "M0 0h8v8H0z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMicrosoft, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/microsoft.ed6ff981.svg";
export { ForwardRef as ReactComponent };